// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"HeaderLight_headerContainer__3WWyr","switch":"HeaderLight_switch__2RJ0c","slider":"HeaderLight_slider__1rVsF","sliderRound":"HeaderLight_sliderRound__1GLhT"};